module.exports = __webpack_public_path__ + "static/OP9-841e9a57cf202a84d7f6b2885cc077fa.gif";